import $ from 'jquery';
import preferences from '../../_nonCommonJs/modules/preferences.js';
import widgetFactory from '../widgetFactory';
import urlParser from '../../Services/urlParser';
import { getActiveLang } from '@openclassrooms/translations';

const WIDGET_NAME = 'socialButtons';
let jsClassName = 'js-socialButtons';
let addthisScript;

window.addthis_config = window.addthis_config || {};
window.addthis_config.pubid = 'ra-4fbe47ef2aab77a6';
window.addthis_config.data_track_addressbar = false;
window.addthis_config.data_track_clickback = false;
window.addthis_config.ui_email_from = preferences.contactMail;

export default widgetFactory(WIDGET_NAME, {
  _create: function () {
    this._super(jsClassName);
    this.elements.$buttons = this.getWidgetElement('btn');
    this.elements.$buttons.addClass('js-tooltip');

    this._prepareButtons();

    if (!addthisScript) {
      addthisScript = document.createElement('script');
      addthisScript.setAttribute('src', '//s7.addthis.com/js/300/addthis_widget.js#domready=1');
      document.body.appendChild(addthisScript);
    }
  },

  _prepareButtons: function () {
    var self = this;

    this.elements.$buttons.each(function (n, element) {
      var $element = $(element),
        sharedUrl = self.options.url || document.location.toString(),
        sharedTitle = self.options.title || '',
        sharedMailSubject = self.options.mailSubject || sharedTitle,
        sharedMailContent = self.options.mailContent || sharedTitle,
        sharedMailTitle = self.options.mailTitle || sharedTitle;

      sharedUrl = urlParser.updateParameter(sharedUrl, 'lang', getActiveLang());

      $element.attr('addthis:url', sharedUrl);

      if ($element.is('.js-socialButtons-email')) {
        $element.attr('addthis:ui_email_title', sharedMailSubject);
        $element.attr('addthis:ui_email_note', sharedMailContent);
        $element.attr('addthis:title', sharedMailTitle);
      } else {
        $element.attr('addthis:title', sharedTitle);
      }

      // remove focus from the link to prevent tooltip mess
      $element.on('click', function () {
        $(this).blur();
      });
    });
  },
});
